import { MuiLinkStyled, RouterLinkStyled } from './styles'

export default {
  External: MuiLinkStyled,
  Internal: RouterLinkStyled,
}
